exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".generate-label[data-v-525f3811] {\n  display: inline;\n}\n.generate-label-btn[data-v-525f3811],\n.generate-label-btn[data-v-525f3811]:hover,\n.generate-label-btn[data-v-525f3811]:focus {\n  background-color: #2b93ff !important;\n  margin-left: 0px;\n}\n", ""]);

// exports
